import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from "@angular/material/bottom-sheet";
import { Router } from "@angular/router";
import { Network } from "@capacitor/network";
import { AuthService } from "@core/auth.service";
import { MySnackBarService } from "@core/my-snack-bar.service";
import { TranslateService } from "@ngx-translate/core";
import { interval } from "rxjs";
import { bounceIn } from "src/app/animations/custom.animation";
import { CommonVariable } from "src/app/app.constants";
import { IonicModule } from "@ionic/angular";
@Component({
    selector: "app-inform-strip",
    templateUrl: "./inform-strip.component.html",
    styleUrls: ["./inform-strip.component.scss"],
    animations: [bounceIn],
    standalone: true,
    imports: [IonicModule],
})
export class InformStripComponent implements OnInit {
  isNumberInvalid: boolean;
  countryCode: any;
  msn: any;
  cell1TelInput = {
    initialCountry: CommonVariable.countryCode,
    separateDialCode: false,
  };
  update = false;
  updateForm: FormGroup;
  currentPasswordIcon = "eye-off";
  currentPasswordType = "password";
  newPasswordIcon = "eye-off";
  newPasswordType = "password";

  @ViewChild("mobileNumber") mobileNumber: ElementRef;
  phoneInValid: boolean = false;
  spinnerAnimation: boolean;
  progressBar: number;
  timer$: any;
  sub: any;
  proceed = true;
  apiFailed: boolean;
  isOnline: boolean = true;
  messageData: any;
  backgroundImage: string;
  constructor(
    private fb: FormBuilder,
    private bottomSheet: MatBottomSheetRef<InformStripComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private authService: AuthService,
    private snackService: MySnackBarService,
    private changeDetectorRef: ChangeDetectorRef,
    public translate: TranslateService,
    private router: Router
  ) {
    this.messageData = data?.message;
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        translate.use(l ? l : "en");
      },
      (err) => {
        return err;
      }
    );
    this.backgroundImage =
      this.messageData?.template_data?.background_url != "" ? this.messageData?.template_data?.background_url : "";
  }

  ngOnInit() {
    Network.addListener("networkStatusChange", (e) => {
      try {
        if (e.connected) {
          this.isOnline = true;
        } else {
          this.isOnline = false;
        }
      } catch (error) {
        return error;
      }
    });
  }

  backToDetails(isLiked) {
    this.bottomSheet.dismiss(isLiked);
  }

  onCTA() {
    this.bottomSheet.dismiss();
    this.router.navigate([this.messageData?.destination]);
  }
}
